module.exports = __webpack_public_path__ + "static/img/login_title.e6ef9e7d.png";